module.exports = __webpack_public_path__ + "static/img/group-7.fa85a4b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/group-7.svg
// module id = HVFK
// module chunks = 1